import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notar al niño",
    opening: localizedGenderNode(
      [
      "Hoy no intento arreglar.",
      "Solo noto al niño interior.",
      "Eso es suficiente por ahora."
    ],
      [
      "Hoy no intento arreglar.",
      "Solo noto al niño interior.",
      "Eso es suficiente por ahora."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo se despierta este niño en mí?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente en mi cuerpo?"
    ],
      [
      "¿Cuándo se despierta este niño en mí?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Notar ya es un pequeño abrazo."
    ],
      [
      "Notar ya es un pequeño abrazo."
    ]
    ),
    action: localizedGenderNode(
      "una respiración con las palabras \"Estoy aquí\".",
      "una respiración con las palabras \"Estoy aquí\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Lo que necesita",
    opening: localizedGenderNode(
      [
      "Hoy noto lo que el niño necesita.",
      "Sin promesas.",
      "Solo ver."
    ],
      [
      "Hoy noto lo que el niño necesita.",
      "Sin promesas.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el pecho."
    ],
      [
      "Respiro despacio.",
      "Siento el pecho."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué le faltó entonces?",
      "¿Qué me pide hoy?",
      "¿Qué me cuesta darle?"
    ],
      [
      "¿Qué le faltó entonces?",
      "¿Qué me pide hoy?",
      "¿Qué me cuesta darle?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Ver la necesidad suaviza algo en mí."
    ],
      [
      "Ver la necesidad suaviza algo en mí."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra sobre la necesidad.",
      "escribir una palabra sobre la necesidad."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "El mensaje que quedó",
    opening: localizedGenderNode(
      [
      "Hoy noto los mensajes que el niño absorbió.",
      "Sin juicio.",
      "Solo verdad."
    ],
      [
      "Hoy noto los mensajes que el niño absorbió.",
      "Sin juicio.",
      "Solo verdad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué mensaje quedó en mí desde entonces?",
      "¿Cómo me afecta ese mensaje hoy?",
      "¿Qué me gustaría cambiar en él?"
    ],
      [
      "¿Qué mensaje quedó en mí desde entonces?",
      "¿Cómo me afecta ese mensaje hoy?",
      "¿Qué me gustaría cambiar en él?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un mensaje antiguo pide un arreglo suave."
    ],
      [
      "Un mensaje antiguo pide un arreglo suave."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra suave en lugar del mensaje.",
      "escribir una palabra suave en lugar del mensaje."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Estar con él",
    opening: localizedGenderNode(
      [
      "Hoy practico estar con el niño un momento.",
      "No para arreglar.",
      "Solo estar."
    ],
      [
      "Hoy practico estar con el niño un momento.",
      "No para arreglar.",
      "Solo estar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el corazón."
    ],
      [
      "Respiro despacio.",
      "Siento el corazón."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde se sienta en mí?",
      "¿Qué necesita de mí ahora?",
      "¿Cómo se siente estar con él un momento?"
    ],
      [
      "¿Dónde se sienta en mí?",
      "¿Qué necesita de mí ahora?",
      "¿Cómo se siente estar con él un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Estar con él un momento ya es un cambio pequeño."
    ],
      [
      "Estar con él un momento ya es un cambio pequeño."
    ]
    ),
    action: localizedGenderNode(
      "poner una mano en el corazón y respirar.",
      "poner una mano en el corazón y respirar."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El miedo a no ser querido/a",
    opening: localizedGenderNode(
      [
      "Hoy noto el miedo a no ser querido/a.",
      "No para pelear.",
      "Solo ver."
    ],
      [
      "Hoy noto el miedo a no ser querido/a.",
      "No para pelear.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo se despierta este miedo?",
      "¿Qué me dice?",
      "¿Cómo intenta protegerme?"
    ],
      [
      "¿Cuándo se despierta este miedo?",
      "¿Qué me dice?",
      "¿Cómo intenta protegerme?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El miedo pide protección."
    ],
      [
      "El miedo pide protección."
    ]
    ),
    action: localizedGenderNode(
      "decirme \"Te veo\".",
      "decirme \"Te veo\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Una petición pequeña de calidez",
    opening: localizedGenderNode(
      [
      "Hoy formulo una petición pequeña de calidez.",
      "No grande.",
      "Pequeña."
    ],
      [
      "Hoy formulo una petición pequeña de calidez.",
      "No grande.",
      "Pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué calidez me falta?",
      "¿Cómo puedo pedirla con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ],
      [
      "¿Qué calidez me falta?",
      "¿Cómo puedo pedirla con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición puede suavizar."
    ],
      [
      "Una petición puede suavizar."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase.",
      "escribir la petición en una frase."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "fear",
    title: "Un pequeño momento de consuelo",
    opening: localizedGenderNode(
      [
      "Hoy busco un pequeño momento de consuelo.",
      "No mucho.",
      "Solo un poco."
    ],
      [
      "Hoy busco un pequeño momento de consuelo.",
      "No mucho.",
      "Solo un poco."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo sentí consuelo recientemente?",
      "¿Qué permitió que ocurriera?",
      "¿Qué podría invitar otro momento así?"
    ],
      [
      "¿Cuándo sentí consuelo recientemente?",
      "¿Qué permitió que ocurriera?",
      "¿Qué podría invitar otro momento así?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un momento pequeño cambia el rumbo."
    ],
      [
      "Un momento pequeño cambia el rumbo."
    ]
    ),
    action: localizedGenderNode(
      "recordar un momento así.",
      "recordar un momento así."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "need",
    title: "Un límite que me protege",
    opening: localizedGenderNode(
      [
      "Hoy observo un límite pequeño que me protege.",
      "No para alejarme.",
      "Solo proteger."
    ],
      [
      "Hoy observo un límite pequeño que me protege.",
      "No para alejarme.",
      "Solo proteger."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento los hombros."
    ],
      [
      "Respiro despacio.",
      "Siento los hombros."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde doy demasiado?",
      "¿Qué límite pequeño me aliviaría?",
      "¿Cómo puedo decírmelo a mí?"
    ],
      [
      "¿Dónde doy demasiado?",
      "¿Qué límite pequeño me aliviaría?",
      "¿Cómo puedo decírmelo a mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un límite pequeño protege el corazón."
    ],
      [
      "Un límite pequeño protege el corazón."
    ]
    ),
    action: localizedGenderNode(
      "una frase de límite para mí.",
      "una frase de límite para mí."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "need",
    title: "Quedarme conmigo",
    opening: localizedGenderNode(
      [
      "Hoy practico quedarme conmigo cuando sube el dolor viejo.",
      "No huir.",
      "Solo estar."
    ],
      [
      "Hoy practico quedarme conmigo cuando sube el dolor viejo.",
      "No huir.",
      "Solo estar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me ayuda a quedarme conmigo?",
      "¿Qué me saca de mí?",
      "¿Qué podría ayudarme a volver?"
    ],
      [
      "¿Qué me ayuda a quedarme conmigo?",
      "¿Qué me saca de mí?",
      "¿Qué podría ayudarme a volver?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Quedarme conmigo es un pequeño ancla."
    ],
      [
      "Quedarme conmigo es un pequeño ancla."
    ]
    ),
    action: localizedGenderNode(
      "una respiración cada vez que suba la sensación.",
      "una respiración cada vez que suba la sensación."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una petición clara",
    opening: localizedGenderNode(
      [
      "Hoy formulo una petición clara para mí.",
      "No grande.",
      "Clara."
    ],
      [
      "Hoy formulo una petición clara para mí.",
      "No grande.",
      "Clara."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesito ahora para sentirme querido/a?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ],
      [
      "¿Qué necesito ahora para sentirme querido/a?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición clara puede calmarme."
    ],
      [
      "Una petición clara puede calmarme."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase.",
      "escribir la petición en una frase."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "perspective",
    title: "Un valor que me sostiene",
    opening: localizedGenderNode(
      [
      "Hoy busco un valor que me sostiene.",
      "Pequeño.",
      "Pero verdadero."
    ],
      [
      "Hoy busco un valor que me sostiene.",
      "Pequeño.",
      "Pero verdadero."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué valor me importa de verdad?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué paso pequeño podría honrarlo?"
    ],
      [
      "¿Qué valor me importa de verdad?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué paso pequeño podría honrarlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un valor puede ser un ancla."
    ],
      [
      "Un valor puede ser un ancla."
    ]
    ),
    action: localizedGenderNode(
      "una palabra que exprese ese valor.",
      "una palabra que exprese ese valor."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "strength",
    title: "Escucharme",
    opening: localizedGenderNode(
      [
      "Hoy practico escucharme con el niño.",
      "No para apartarla.",
      "Solo escuchar."
    ],
      [
      "Hoy practico escucharme con el niño.",
      "No para apartarla.",
      "Solo escuchar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el corazón."
    ],
      [
      "Respiro despacio.",
      "Siento el corazón."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesito escuchar de mí hoy?",
      "¿Qué doy a otros que no me doy a mí?",
      "¿Cómo puedo darme eso a mí?"
    ],
      [
      "¿Qué necesito escuchar de mí hoy?",
      "¿Qué doy a otros que no me doy a mí?",
      "¿Cómo puedo darme eso a mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Escucharme es una pequeña reparación."
    ],
      [
      "Escucharme es una pequeña reparación."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mí.",
      "una frase suave para mí."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "strength",
    title: "Un paso pequeño de aceptación",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño de aceptación.",
      "Sin drama.",
      "Un paso pequeño."
    ],
      [
      "Hoy elijo un paso pequeño de aceptación.",
      "Sin drama.",
      "Un paso pequeño."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ],
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un paso pequeño es suficiente para moverme."
    ],
      [
      "Un paso pequeño es suficiente para moverme."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño y recordarlo.",
      "elegir un paso pequeño y recordarlo."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy elijo una frase que me devuelve al amor interno.",
      "Cuando tiemblo.",
      "Una frase pequeña."
    ],
      [
      "Hoy elijo una frase que me devuelve al amor interno.",
      "Cuando tiemblo.",
      "Una frase pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre este niño?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ],
      [
      "¿Qué aprendí sobre este niño?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo encontrarlo y aun así quedarme conmigo."
    ],
      [
      "Puedo encontrarlo y aun así quedarme conmigo."
    ]
    ),
    action: localizedGenderNode(
      "decir la nueva frase una vez.",
      "decir la nueva frase una vez."
    ),
  },
].map(buildNormalizedDay);

export const anInnerChildWhoDidnTFeelWantedLovedBlueprintEs = buildNormalizedPilotBlueprint({
  id: "an_inner_child_who_didn_t_feel_wanted_loved_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "an_inner_child_who_didn_t_feel_wanted_loved",
  category: "childhood_parents_past_wounds",
  journeyName: {
    he: "ילד פנימי שלא הרגיש רצוי / אהוב",
    en: "An inner child who did not feel wanted / loved",
    es: "Un niño interior que no se sintió querido / amado",
  },
  days,
});

export default anInnerChildWhoDidnTFeelWantedLovedBlueprintEs;
